import { all } from 'redux-saga/effects';
import authenticated from './authenticated/sagas';

export default function* rootSaga(): any {
  return yield all([ authenticated ])
}